import * as React from "react";
import { useState } from "react";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  Chip,
  Typography,
} from "@mui/material";
import { OrderShipmentStatusEnumIcons, CourierEnum, OrderShipmentTypeEnum } from "src/common/enum";
import { priceFormat, formatDateTime } from "src/common/UtilFunctions";
import { TrackingModal } from "src/resources/sales";

export const ShipmentTable = (props) => {
    const { record, ...rest } = props;

    const [trackingOpen, setTrackingOpen] = useState(false);
    const [viewShipment, setSiewShipment] = useState([]);


    const openTracking = (shipment) => {
        setSiewShipment(shipment);
        setTrackingOpen(true);
    }

    return (
        <>
        <TableContainer sx={{border: "1px solid #ebebeb", borderRadius: "8px", boxShadow: "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)"}}>
            <Table size="small">
                <TableHead>
                <TableRow>
                    <TableCell>
                    Id
                    </TableCell>
                    <TableCell>
                    Courier
                    </TableCell>
                    <TableCell>
                    AWB
                    </TableCell>
                    <TableCell>
                    Amount
                    </TableCell>
                    <TableCell>
                    Description
                    </TableCell>
                    <TableCell>
                    Type
                    </TableCell>
                    <TableCell>
                    Delievered
                    </TableCell>
                    <TableCell>
                    Created At
                    </TableCell>
                    <TableCell>
                    Status
                    </TableCell>
                    <TableCell />
                </TableRow>
                </TableHead>

                <TableBody>
                { record.shipments.map((shipmentItem, shipmentItemIndex) => {
                    let statusEnum = OrderShipmentStatusEnumIcons.find((status) => status.id === shipmentItem.status);
                    let courierEnum = CourierEnum.find((courier) => courier.id === shipmentItem.courier);
                    let typeEnum = OrderShipmentTypeEnum.find((type) => type.id === shipmentItem.type);

                    return (
                        <TableRow key={`row_${shipmentItemIndex}`} >
                            <TableCell>
                            {shipmentItem.id}
                            </TableCell>
                            <TableCell>
                            {courierEnum && courierEnum.name}
                            </TableCell>
                            <TableCell  sx={{width: "100px"}}>
                            {shipmentItem.awb}
                            </TableCell>
                            <TableCell>
                            {priceFormat(shipmentItem.amount, record.currency)}
                            </TableCell>
                            <TableCell>
                            {shipmentItem.description}
                            </TableCell>
                            <TableCell>
                            {typeEnum && typeEnum.name}
                            </TableCell>
                            <TableCell>
                            {formatDateTime(shipmentItem.delivered_at)}
                            </TableCell>
                            <TableCell>
                            {formatDateTime(shipmentItem.created_at)}
                            </TableCell>
                            <TableCell>
                            {statusEnum &&
                                <Chip sx={{fontSize: "12px", padding: "4px 6px", height: "auto"}} label={statusEnum.name} color={statusEnum.color as any} icon={statusEnum.icon}/>
                            }
                            </TableCell>
                            {shipmentItem.awb &&
                            <TableCell 
                                className="SplitItemView"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Button onClick={() => openTracking(shipmentItem)}>View</Button>
                            </TableCell>
                            }
                        </TableRow>
                    )   
                })}
                </TableBody>
            </Table>
        </TableContainer>

        { trackingOpen &&
        <TrackingModal
            open={trackingOpen}
            setOpen={setTrackingOpen}
            shipment={viewShipment}
            title={"Tracking"}
        />
        }

        </>
    );
}
